function scrollToHash(hash) {
  const target = document.getElementById(hash.slice(1))
  if (!target) return

  const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--headerHeight'),
    10
  ) || 0

  const top = target.getBoundingClientRect().top + window.scrollY - headerHeight

  window.scrollTo({ top, behavior: 'smooth' })
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="#"]')
  if (!link) return

  const rawHref = link.getAttribute('href') || ''
  const isBareHashLink = rawHref.startsWith('#')
  const url = new URL(link.href, window.location.origin)
  if (url.pathname !== window.location.pathname && !isBareHashLink) return
  if (!url.hash) return

  const target = document.getElementById(url.hash.slice(1))
  if (!target) return

  e.preventDefault()
  history.pushState(null, '', url.hash)
  scrollToHash(url.hash)
})

if (window.location.hash) {
  window.addEventListener('load', () => {
    setTimeout(() => scrollToHash(window.location.hash), 100)
  })
}
